import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router";
import { createRoot } from "react-dom/client";

import "./scss/theme.scss";

import App from "./App";

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
